<template>
  <div :style="frameStyle">
    <div class="input-component">
      <span
        v-if="label !== '' ? true : false"
        :class="['input-label', disabled ? 'disabled' : '']"
        :style="labelStyle"
        >{{ label }}</span
      >
      <b-form-input
        :id="id"
        :class="['input-field', colorType, errorText ? 'error-border' : '']"
        :style="inputStyle"
        v-model="inputValue"
        :number="isNumber"
        type="text"
        :maxLength="maxLength"
        :disabled="disabled"
        :placeholder="placeholder"
        :formatter="format"
        :autocomplete="autocomplete"
        :state="errorText !== '' ? false : null"
        aria-describedby="input-live-feedback"
        @input="onInput(inputValue)"
        @change="onChange(inputValue)"
        @blur="onBlur(inputValue)"
        @keypress="onkeyPress($event)"
        trim
      ></b-form-input>
      <span class="input-unit-label" v-if="unitText">{{ unitText }}</span>

      <img
        class="input-cap-lock-icon"
        v-if="capLock"
        src="~@/assets/images/capLock.png"
      />
    </div>
    <div class="clear" v-if="false == errorText">{{ ' ' }}</div>
    <b-form-invalid-feedback
      id="input-live-feedback"
      class="input-error-text"
      :style="unitText ? { paddingRight: '40px' } : {}"
      v-if="errorText"
      >{{ errorText }}</b-form-invalid-feedback
    >
  </div>
</template>

<script>
import Vue from 'vue';
import { BFormInput, BFormInvalidFeedback } from 'bootstrap-vue';

Vue.component('b-form-input', BFormInput);
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback);

export default {
  name: 'InputField',
  data() {
    return {
      inputValue: '',
      capLock: '',
    };
  },
  props: {
    frameStyle: {
      type: Object,
      default: () => {},
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    inputStyle: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    colorType: {
      type: String,
      default: '',
    },
    maxLength: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    errorText: {
      type: String,
      default: '',
    },
    unitText: {
      type: String,
      default: '',
    },
  },
  computed: {
    isNumber() {
      // convert the input value to a native number
      switch (this.inputType) {
        case 'number':
        case 'int':
        case 'signedInteger':
          return true;
        default:
          return false;
      }
    },
    type() {
      // the type of input to render
      switch (this.inputType) {
        case 'password':
          return this.inputType;
        default:
          return 'text';
      }
    },
  },
  watch: {
    value: function() {
      this.inputValue = this.inputType ? this.format(this.value) : this.value;
    },
  },
  methods: {
    format(value) {
      let newValue = value;
      switch (this.inputType) {
        case 'number':
          if (value === null || value === undefined) {
            value = '';
          }
          newValue = value
            .toString()
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1');
          break;
        case 'int':
          if (value === null || value === undefined) {
            value = '';
          }
          newValue = value.toString().replace(/[^0-9]/g, '');
          break;
        case 'signedInteger':
          if (value === null || value === undefined) {
            value = '';
          }
          newValue = value.toString().replace(/[^0-9-]/g, '');
          break;
        case 'unitsDigit':
          newValue = value
            .toString()
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1');

          //判斷unit輸入值(僅可1位整數+4位小數)
          if (newValue >= 10) {
            newValue = newValue.replace(/[^0-9]/g, '');
            newValue = newValue.slice(0, 1) + '.' + newValue.slice(1);
          }

          if (
            newValue !== '' &&
            !/((^[0-9]{1}$)|(^[0-9]{1}[.]{1}[0-9]{0,4}$))/g.test(newValue)
          ) {
            newValue = parseFloat(newValue) || 0;
          }
          break;
        case 'name':
          newValue = value.replace(
            /[^\u2E80-\u9FFF\u3105-\u3129\u02CA\u02C7\u02CB\u02D9\uff3fA-Za-z0-9]+$/,
            ''
          );
          break;
        case 'account':
          newValue = value.replace(/[^A-Za-z0-9]/g, '');
          break;
        case 'email':
          newValue = value.replace(/[^a-zA-Z0-9@_\-.]+$/, '');
          break;
        case 'digit':
          if (value === null || value === undefined) {
            value = '';
          }
          newValue = value.toString().replace(/[^0-9]/g, '');
          break;
        case 'thousands':
          if (value || value === 0) {
            newValue = value
              .toString()
              .replace(/[^0-9]/g, '')
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          break;
        case 'percentage':
          if (value || value === 0) {
            newValue = value
              .toString()
              .replace(/[^0-9%.]/g, '')
              .concat('%');
            break;
          }
          newValue = '';
          break;
        case 'PAX':
          newValue = value.replace(/[^0-9/]/g, '');
          break;
        case 'phone':
          newValue = value.replace(/[^0-9]/g, '');
          break;
        case 'address':
          newValue = value.replace(/^\s+$/g, '');
          break;
      }
      return newValue;
    },
    onInput(value) {
      let data = {};
      data[this.id] = value;
      this.$emit('onInput', data);
    },
    onChange(value) {
      let data = {};
      data[this.id] = value;
      this.$emit('onChange', data);
    },
    onBlur(value) {
      let data = {};
      data[this.id] = value;
      this.$emit('onBlur', data);
      // if (this.inputType === 'password' && this.capLock) {
      //   this.capLock = false;
      // }
    },
    onkeyPress(event) {
      // input為密碼，才需進行以下判斷
      if (this.inputType === 'password') {
        let kc = event.keyCode ? event.keyCode : event.which,
          sk = event.shiftKey ? event.shiftKey : kc == 16 ? true : false;

        // 沒按下Shift鍵，卻輸入大寫字母
        // 或
        // 按下Shift鍵時，卻輸入小寫字母
        if ((kc >= 65 && kc <= 90 && !sk) || (kc >= 97 && kc <= 122 && sk)) {
          this.capLock = true;
        } else {
          this.capLock = false;
        }
      }

      if (event.keyCode == 13) {
        this.$emit('onEnter');
      }
    },
  },
  created() {
    if (this.value || this.value === 0) {
      this.inputValue = this.inputType ? this.format(this.value) : this.value;
    }
  },
  beforeUpdate() {
    // if (this.value) {
    // this.inputValue = this.inputType ? this.format(this.value) : this.value;
    // }
  },
};
</script>

<style scoped>
.input-component {
  width: 100%;
  position: relative;
  display: flex;
  height: auto;
  min-height: 65px;
  /* align-items: center;
  justify-content: flex-end; */
}
#input-live-feedback {
  display: block;
  font-size: 12px;
  color: #c34040;
  text-align: right;
  margin-top: -3px;
  max-width: fit-content;
  margin-left: auto;
}

.input-label {
  text-align: center;
  margin-left: 16px;
  color: #b18147;
  font-size: 12px;
  font-weight: bold;
  background-color: #ffffff;
  z-index: 2;
  padding: 0px 3px 0px 3px;
  height: 20px;
}

.input-field {
  height: auto;
  min-height: 56px;
  /* background-color: rgba(216, 216, 216, 0.2); */
  border: 1px solid rgba(70, 70, 70, 0.8);
  border-radius: 4px;
  display: inline-block;
  z-index: 1;
  top: 9px;
  left: 0px;
  position: absolute;
  width: 100%;
}

.input-error-text {
  height: auto;
  min-height: 16px;
  text-align: right;
  bottom: 0;
  position: relative;
  word-wrap: break-word;
  padding-top: 3px;
}

.clear {
  width: 100%;
  height: 16px;
  position: relative;
}

/* 隱藏safari 原生大寫標示&密碼自動填入 */
input.input-field::-webkit-credentials-auto-fill-button,
input.input-field::-webkit-caps-lock-indicator {
  display: none !important;
}

.input-field:focus {
  background-color: rgb(255, 255, 255);
  box-shadow: 0 0 0 0;
  border-color: #647282;
}

.input-field:hover {
  border: 1px solid rgba(70, 70, 70, 0.5);
}

.input-field:disabled,
.input-field[readonly] {
  background-color: #ffffff;
  border-color: rgba(70, 70, 70, 0.3);
}

.input-field.white {
  background-color: rgb(255, 255, 255);
  border: none;
  border-bottom: 1px solid #a2a2a2;
}

.input-field.white:focus {
  background-color: rgb(255, 255, 255);
}

.input-field.is-invalid {
  background-image: initial;
  padding-right: initial;
}

.input-cap-lock-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.input-unit-label {
  display: inline-block;
  font-size: 12px;
  text-decoration: underline;
  width: 40px;
  text-align: right;
}

.input-label.disabled {
  color: gray;
}
</style>
